import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class PlaceholderWrapperComponentComponentProps extends BaseProps {
  className: String;
}

export const PlaceholderWrapperComponent = ((props: PlaceholderWrapperComponentComponentProps) => {
  return (
    <div className={'placeholder-wrapper'}>
      <div className={[props.className, 'placeholder-container'].join(' ')} style={props.style}>
        <div className={'placeholder-gradient-animation'}/>
      </div>
      <div className={'placeholder-content'}>
          {
          props.children
        }
      </div>
    </div>
  )
});
